import { AuthService } from 'src/app/services/auth/auth.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs/operators';


export const canActivateAdminRoute: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.adminData$.pipe(
    map((data) => {
      if(!data) {
        return router.createUrlTree(['','auth']);
      }
      if(route.data.super && !data.super) {
        return router.createUrlTree(['']);
      }
      return true;
    }),
  );
};
